<div class="table-container">
  <table class="display" id="messagesChatsTable"></table>
</div>